import * as React from "react"
import { cn } from "./utils"

type OnValueChange = (value: number[]) => void

interface SliderProps
    extends Omit<
        React.InputHTMLAttributes<HTMLInputElement>,
        "onChange" | "value" | "defaultValue"
    > {
    value?: number[] // [current]
    defaultValue?: number[] // [initial]
    onValueChange?: OnValueChange
    min?: number
    max?: number
    step?: number
}

function Slider({
    className,
    value,
    defaultValue,
    onValueChange,
    min = 0,
    max = 100,
    step = 1,
    ...props
}: SliderProps) {
    const isControlled = Array.isArray(value)
    const [inner, setInner] = React.useState<number>(
        Array.isArray(defaultValue) ? Number(defaultValue[0]) : min
    )

    const current = isControlled ? Number(value![0]) : inner

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const v = Number(e.target.value)
        if (!isControlled) setInner(v)
        onValueChange?.([v])
    }

    return (
        <div
            data-slot="slider"
            className={cn(
                "relative flex w-full items-center select-none",
                className
            )}
        >
            <input
                type="range"
                min={min}
                max={max}
                step={step}
                value={current}
                onChange={handleChange}
                className="w-full h-1.5 appearance-none rounded-full bg-muted accent-current
                   [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:size-4
                   [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-background
                   [&::-webkit-slider-thumb]:border [&::-webkit-slider-thumb]:border-muted-foreground
                   focus:outline-none focus-visible:ring-4 focus-visible:ring-ring/50"
                {...props}
            />
        </div>
    )
}

export { Slider }
